/**
In this index.js file we initialize our project using ReactDOM.createRoot keyword and also use React Provider(store) concept to store the any Custom details data in this project
**/
import React from 'react';
import ReactDOM from 'react-dom/client';
//import { HashRouter } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';  
import MainRoutes from './Routes';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from 'react-redux';
import store from './store.js';
import LoadingBar from './shared/components/LoadingBar.js';
import './i18n.js';

const role = Number(localStorage.getItem('role'));
const root = ReactDOM.createRoot(document.getElementById('root'));

	if (role === 4) {
		document.body.id = 'admin-root';
	} else {
		document.body.id = ''; // Clear the id when role is not 4
	}
root.render(
	<Provider  store={store}> {/*To store details in redux and access in any components*/}
		{/*<HashRouter>*/}
			<BrowserRouter>
		<ToastContainer 
		autoClose={2500}
			closeOnClick={true}
			pauseOnFocusLoss={false}
			pauseOnHover={ false}
		/>{/* Toster */}
		<LoadingBar /> {/* Loading bar */}
		<MainRoutes /> {/* Route Declaration */}
			{/*</HashRouter>*/}
				</BrowserRouter>
	</Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

